/**
 * Error that is thrown on stack underflows or when accessing the
 * stack outside of a lambda function's range.
 */
class InvalidStackAccessError extends Error {
}

module.exports = InvalidStackAccessError



//////////////////
// WEBPACK FOOTER
// ../postfixjs/InvalidStackAccessError.js
// module id = 164
// module chunks = 53